import { ReactElement, useState } from "react";
import "./TabList.scss";
import TabTitle, { TabTitleProps } from "./components/tab-title/TabTitle";

interface ITabListProps {
  children: ReactElement<TabTitleProps>[];
  preSelectedTabIndex?: number;
}

const TabList = (props: ITabListProps) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    props.preSelectedTabIndex || 0
  );

  return (
    <div className="tab-list">
      <div className="tab-nav">
        {props.children.map((tab, index) => {
          return (
            <TabTitle
              key={"tab_" + tab.props.title}
              title={tab.props.title}
              index={index}
              isActive={index === selectedTabIndex}
              setSelectedTab={setSelectedTabIndex}
              icon={tab.props.icon}
            />
          );
        })}
      </div>
      <div className="tab-content">{props.children[selectedTabIndex]}</div>
    </div>
  );
};

export default TabList;
